import {
    ApiActionStatus,
    type AppState,
    type Destinations,
    type Facets,
    type Filters,
    type HotelOffersResponse,
    type HotelResponse,
    type MapOffersResponse,
    type OffersResponse,
    type PaleState,
} from '@/interfaces';

const defaultHotel: HotelResponse = {
    id: '',
    name: '',
    tripAdvisorId: '',
    rating: 0,
    country: '',
    region: '',
    destination: '',
    facilities: [],
    activities: [],
    distanceToBeach: 0,
    distanceToCity: 0,
    imagePaths: [],
};

export const defaultHotelResults: HotelOffersResponse = {
    numberOfOffers: 0,
    totalPages: 0,
    currentPage: 0,
    offers: [],
    sortOptions: [],
    defaultSort: '',
    status: ApiActionStatus.NOT_STARTED,
};

const defaultFacets: Facets = {
    location: [],
    originAirport: [],
    charterSuppliers: [],
    nonCharterSuppliers: [],
    activities: [],
    facilities: [],
    meals: [],
};

const defaultResults: OffersResponse = {
    numberOfHotels: 0,
    totalPages: 0,
    currentPage: 0,
    offers: [],
    facets: defaultFacets,
    sortOptions: [],
    defaultSort: 'best',
    status: ApiActionStatus.NOT_STARTED,
};

const defaultMapResults: MapOffersResponse = {
    numberOfHotels: 0,
    offers: [],
    status: ApiActionStatus.NOT_STARTED,
};

const defaultDestinations: Destinations = {
    list: [],
    tree: {},
};

export const defaultFilters: Filters = {
    origin: '',
    destinations: defaultDestinations,
    meals: {},
    facilities: {},
    activities: {},
    keywords: '',
    suppliers: {},
    rating: {},
    travelMonths: [],
    ignoredFilters: [],
    departureDate: { flexibility: 3 },
    returnDate: { flexibility: 3 },
    numberOfAdults: 2,
    agesOfChildren: [],
    boundingBox: undefined,
};

const defaultAppState: AppState = {
    filtersOpen: false,
};

const defaultState: PaleState = {
    hotel: defaultHotel,
    hotelResults: defaultHotelResults,
    results: defaultResults,
    mapResults: defaultMapResults,
    filters: defaultFilters,
    appState: defaultAppState,
};

export default defaultState;
